import React from "react";
import { motion } from "framer-motion";
import {
  School,
  Computer,
  DesignServices,
  VideoLibrary,
  BarChart,
  SupportAgent,
} from "@mui/icons-material";

const services = [
  {
    icon: <School fontSize="large" />,
    title: "Computer Education",
    desc: "From basic computer fundamentals to advanced diploma programs designed for real-world industry needs.",
  },
  {
    icon: <BarChart fontSize="large" />,
    title: "Professional Accounting",
    desc: "Tally Prime with GST, income tax basics, payroll, compliance, and practical accounting projects.",
  },
  {
    icon: <Computer fontSize="large" />,
    title: "Advanced Excel & Data Analytics",
    desc: "Advanced Excel, Power BI, SQL, dashboards, MIS reports, and real business analytics training.",
  },
  {
    icon: <DesignServices fontSize="large" />,
    title: "Graphic Designing",
    desc: "Professional design training using Photoshop, Illustrator, CorelDRAW with portfolio development.",
  },
  {
    icon: <VideoLibrary fontSize="large" />,
    title: "Video Editing & Animation",
    desc: "Premiere Pro, DaVinci Resolve, motion graphics, YouTube workflows & freelance guidance.",
  },
  {
    icon: <SupportAgent fontSize="large" />,
    title: "Career Support",
    desc: "Interview preparation, freelancing guidance, portfolio building & placement assistance.",
  },
];

export default function Services() {
  return (
    <div className="font-[Lato]">

      {/* ================= HERO SECTION ================= */}
      <section className="bg-gradient-to-r from-[#ff7a18] to-[#ff9f43] text-white py-20 px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-4xl md:text-5xl font-extrabold"
        >
          Our Services
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-4 max-w-3xl mx-auto text-lg"
        >
          Empowering students with industry-ready skills through quality education,
          practical learning, and career-oriented training.
        </motion.p>
      </section>

      {/* ================= SERVICES GRID ================= */}
      <section className="py-20 px-6 lg:px-20 bg-gray-50">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-orange-100 text-[#ff7a18] mb-4 group-hover:bg-[#ff7a18] group-hover:text-white transition">
                {service.icon}
              </div>

              <h3 className="text-xl font-bold mb-2">
                {service.title}
              </h3>

              <p className="text-gray-600 text-sm leading-relaxed">
                {service.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ================= WHY CHOOSE US ================= */}
      <section className="py-20 px-6 lg:px-20 bg-white">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-5xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">
            Why Choose <span className="text-[#ff7a18]">TGCI?</span>
          </h2>

          <p className="mt-4 text-gray-600 text-lg">
            We focus on practical skills, affordability, and career growth.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-12">
            {[
              "Industry-Focused Curriculum",
              "Experienced Trainers",
              "Practical & Project-Based Learning",
              "Affordable Fees Structure",
              "Certification & Career Support",
              "Modern Labs & Tools",
            ].map((point, i) => (
              <div
                key={i}
                className="bg-gray-50 p-5 rounded-xl shadow-sm"
              >
                <span className="text-[#ff7a18] font-bold text-lg">✔</span>
                <p className="mt-2 text-gray-700 font-medium">{point}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </section>

      {/* ================= CTA SECTION ================= */}
      <section className="bg-gradient-to-r from-[#ff7a18] to-[#ff9f43] text-white py-16 px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-extrabold"
        >
          Ready to Upgrade Your Skills?
        </motion.h2>

        <p className="mt-4 text-lg">
          Join Techno Gyan Computer Institute and build your future today.
        </p>

        <a href="/contact">
          <button className="mt-6 bg-white text-[#ff7a18] px-8 py-3 rounded-full font-bold shadow-lg hover:scale-105 transition">
            Contact Us Now →
          </button>
        </a>
      </section>
    </div>
  );
}
